import { BkRoutes } from 'bkng';

import { outletPlatform } from '@ngr/outlet-platform';
import { routeStartingPoint } from '@ngr/route-starting-point';

import { DomainConfigsViewComponent } from '@c/domain-configs-view/domain-configs-view.component';
import { DomainViewComponent } from '@c/domain-view/domain-view.component';

import { configs } from './configs/configs';

export const id: BkRoutes = [
    {
        path: ":domainId",
        label: "Organization by ID Domains by ID Domain",
        ngRoute: routeStartingPoint([
            outletPlatform({component: DomainViewComponent}),
        ]),
        children: [
            {
                path: "configs",
                label: "Domain Configs",
                ngRoute: routeStartingPoint([
                    outletPlatform({component: DomainConfigsViewComponent}),
                ]),
                children: configs,
            },
        ],
    },
];
